import React from 'react';
import { observer } from 'mobx-react';
import { Menu, Text } from 'core/components';
import KaizenListItem from './KaizenListItem';

const KaizenList = ({
  journeys,
  hideUserName = false,
  hideEditedDate = true,
  hideShareLevel = false,
  onSelectJourney,
  isCopilotMode,
  dense = false,
  emptyText = 'No chats matched your search criteria.'
}) => (
  <Menu p={0}>
    {journeys?.length === 0 ? (
      <Text muted small>
        {emptyText}
      </Text>
    ) : null}
    {journeys.map((journey) => (
      <KaizenListItem
        journey={journey}
        hideUserName={hideUserName}
        hideEditedDate={hideEditedDate}
        hideShareLevel={hideShareLevel}
        key={journey.id}
        onSelectJourney={onSelectJourney}
        isCopilotMode={isCopilotMode}
        dense={dense}
      />
    ))}
  </Menu>
);

export default observer(KaizenList);
